<template>
  <div class="wrcLogin tc">
    <div class="title mb40">泰安医药</div>
    <div class="tips" v-if="isUserLogin == false">请通过指纹验证身份登录</div>
    <div class="tips" v-if="isUserLogin == true">请输入你的账号和密码</div>
    <div class="content flex" v-show="isUserLogin == false">
      <div class="item">
        <div class="img">
          <div class="img2"><img src="../../../static/images/icon3.png" alt=""></div>
          <div class="loginTips">若手指过于干燥导致无法识别,<br>请用账号登入或保持手指滋润</div>
        </div>
      </div>
    </div>
    <div class="content2" v-show="isUserLogin == true">
      <el-form ref="form" :model="userform" label-width="2rem">
        <el-form-item label="账号：">
          <el-input v-model="userform.username" class="input" @input="reTime"></el-input>
        </el-form-item>
        <el-form-item label="密码：">
          <el-input v-model="userform.password" class="input" type="password" @input="reTime" @keyup.enter.native="getLoginWs"></el-input>
          <!-- <el-input v-model="userform.password" class="input" type="password"></el-input> -->
        </el-form-item>
        <el-form-item>
          <el-button v-if="isLoading==false" type="primary" class="confirm " @click="getLoginWs">登 录</el-button>
          <el-button v-else type="primary" class="confirm isLoading"><img src="../../../static/images/a.gif"/>登 录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="userLoginBtn">
      <el-button type="info" v-if="isUserLogin==false" @click="isUserLogin=true;isErrorLogin=false">账号登录</el-button>
      <el-button type="info" v-if="isUserLogin==true" @click="isUserLogin=false">指纹登录</el-button>
    </div>
    <div class="errorLogin" v-if="isErrorLogin == true"><i class="el-icon-warning"></i>请重新验证...</div>
    <el-button class="backUp" @click="backUp">返回</el-button>
    <!-- <mqttws :topic="topic" :msg="msg" :isConnect="isConnect" ref="mqttws" @getMessage="getMessage"></mqttws> -->
    <currtime :isShowInfo="false"></currtime>
    <!-- <socket ref="socket" @getSkMsg="getSkMsg" :isSendSk="isSendSk" :sendMsg="sendMsg"></socket> -->
  </div>
</template>

<script>
import currtime from '../../assets/currTime'
import mqttws from '../../assets/mqttws'
import { loginApi,borrowApi } from '../../../static/js/api.js'
import { localUserInfo,text2Audio,getMp3 } from '../../../static/js/utils/utility.js'
import {checkData} from '../../../static/js/utils/util.js'
import * as config from '../../../static/js/config.js';
import loginSuccessMp3 from '../../../static/mp3/loginSuccess.mp3'
import noUserMp3 from '../../../static/mp3/noUser.mp3'
import noAdminMp3 from '../../../static/mp3/noAdmin.mp3'
import noOutMp3 from '../../../static/mp3/noOutMp3.mp3'

import noUser2Mp3 from '../../../static/mp3/noUser2.mp3'
import noUser3Mp3 from '../../../static/mp3/noUser3.mp3'
import zhmmcwMp3 from '../../../static/mp3/zhmmcw.mp3'
import orderOverMp3 from '../../../static/mp3/orderOver.mp3'

// import socket from '../../assets/socket'
import {websocketsend} from  '../../../static/js/utils/socket.js'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'wrcLogin',
  data () {
    return {
      topic:'/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol',
      msg:'',
      isConnect:true,//是否默认订阅

      showBtn:false,
      num:0,//点击次数

      isType:'',

      isUserLogin:false,
      userform:{
        username:'',
        password:'',
      },
      overtime:60,//超时
      overtimeStatus:'',//超时状态

      isLoginTips:false,

      isErrorLogin:false,
      loginNumTip:0,
      logintime:3,//登录提示超时
      logintimeStatus:'',//登录提示超时状态

      isLoading:false,

      //socket
      // sendMsg:'A5555505',
    }
  },
  mounted(){
    // getMp3('03')
  },
  components:{
    mqttws,
    currtime,
    // socket,
  },
  created() {
    var that = this
    // websocketsend(this.sendMsg);
    
    this.isType = this.$route.query.isType
    this.overTime(this.overtime)
    // this.currMp3()
  },
  methods:{
    currMp3(){
      var that = this;
      var url = noAdminMp3
      var audio = new Audio(url);
      audio.src = url;
      audio.play();
      audio.addEventListener('ended', function () {
        getMp3('05',() =>{
          that.nextMp3()
        })
      }, false);
      
    },
    //下一个音频
    nextMp3(){
      var url = noUserMp3
      var audio = new Audio(url);
      audio.src = url;
      audio.play();
    },
    //账号密码登录（websocket）
    getLoginWs(){
      var that = this
      var nameSpace = that.userform.username.replace(/(^\s*)|(\s*$)/g, "")
      var username = new RegExp(/^\w{5,20}$/)
      var passSpace = that.userform.password.replace(/(^\s*)|(\s*$)/g, "")
      var password = new RegExp(/^[\w\.]{5,20}$/)
      if(nameSpace == ''){
        that.$message.warning('账号不能为空！')
        return
      }else if(!username.test(nameSpace)){
        that.$message.warning('请输入5-20个字母、数字或下划线的账号！')
        return
      }
      if(passSpace == ''){
        that.$message.warning('密码不能为空！')
        return
      }else if(!password.test(passSpace)){
        that.$message.warning('请输入5-20个字母、数字、小数点或下划线的密码！')
        return
      }
      var sendMsg = 'd709,'+this.userform.username+','+this.userform.password+','
      websocketsend(sendMsg)
      this.isLoading = true
    },
    //接收socket
    getSkMsg(res){
      var that = this;
      console.log('res',res)
      that.overtime=60
      if(res.meta.type == 'finger' || res.meta.type == 'card' || res.meta.type == 'login'){
        that.isLoading = false
        if (res.meta.code == 200) {
        if(res.data){
          if(that.loginNumTip > 1){
            clearTimeout(that.logintimeStatus)
          }
          that.isErrorLogin = false;//关闭错误提示
          // that.loginNumTip = 0
          localUserInfo.setItem(res.data)
          that.$store.state.eUserInfo = localUserInfo.getItem()
          // sessionStorage.setItem('acceToken',res.data.access_token)
          clearTimeout(that.overtimeStatus)
          if(that.isType == 'wrc'){
            if(res.data.is_admin == '0'){
              if(that.isLoginTips == false){
                that.$message({
                  message: '登录成功！',
                  type: 'success',
                  duration:1000
                });
                var url = loginSuccessMp3
                var audio = new Audio(url);
                audio.src = url;
                audio.play();
              }
              that.isLoginTips = true
              // that.$refs.mqttws.disconnect()
              setTimeout(function () {
                that.toAbiosign()
              }, 1000);
            }else{
              that.$message({
                message: '您没有管理员权限~',
                type: 'error',
                duration:1000
              });
              // text2Audio('您没有管理员权限')
              var url = noAdminMp3
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
              setTimeout(function () {
                // that.$refs.mqttws.disconnect()
                that.$router.push({
                  path:'/unmanned/wrcIndex'
                })
              }, 1000);
            }
          }else if(that.isType == 'outStock'){
            that.toOutStock(res.data,res.meta.message)
          }else if(that.isType == 'inStock'){
            
            that.toInStock(res.data,res.meta.message)
          }
        }
        }else {
          var userInfo = localUserInfo.getItem()
          if(!userInfo){
            if(that.loginNumTip == 0){
              if(that.isErrorLogin == false){
                if(res.meta.code == 400){
                  that.$message.error('账号密码错误')
                  var url = zhmmcwMp3
                  var audio = new Audio(url);
                  audio.src = url;
                  audio.play();
                }else if(res.meta.code==401){
                  that.$message.error('暂无该用户，请稍后再试')
                  var url = noUser2Mp3
                  var audio = new Audio(url);
                  audio.src = url;
                  audio.play();
                }
                else if(res.meta.code==402){
                  that.$message.error('没有该用户，无法登录')
                  var url = noUser3Mp3
                  var audio = new Audio(url);
                  audio.src = url;
                  audio.play();
                }
                // text2Audio(res.meta.message);//错误提示语音
              }
            }else{
              that.logintime=3;
              if(that.loginNumTip == 1){
                that.loginTime(that.logintime)
              }
              that.isErrorLogin = true
            }
            that.loginNumTip+=1;
            that.overtime=60
          }
        }
      }else{ 
        that.isLoading = false
        var userInfo = localUserInfo.getItem()
          if(!userInfo){
            if(that.loginNumTip == 0){
              if(that.isErrorLogin == false){
                if(res.meta.code == 300){
                  that.$message.error('订单已满，无法登录')
                  var url = orderOverMp3
                  var audio = new Audio(url);
                  audio.src = url;
                  audio.play();
                } 
              }
            }else{
              that.logintime=3;
              if(that.loginNumTip == 1){
                that.loginTime(that.logintime)
              }
              that.isErrorLogin = true
            }
            that.loginNumTip+=1;
            that.overtime=60
          }
        
      }
      
    },



    reTime(){
      this.overtime = 60
    },
    //返回
    backUp(){
      clearTimeout(this.overtimeStatus)
      // this.$refs.mqttws.disconnect()
      this.$router.push({
        path:'/unmanned/wrcIndex',
      })
    },
    getMessage(data){
      var that = this;
      // if(data){
      //   var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
      //   var num = checkData(str)
      //   var bbc = data.substr(data.length-2)
      //   var type = str.substring(26,30)
      //   if(type == 'df0a'){
      //     that.overtime=60
      //     var lastTwo = str.substring(34,36)
      //     var id = str.substring(str.length-4,str.length)
      //     if(lastTwo == 55 && num == bbc){
      //       that.getLogin(id)
      //     }else{
      //       // text2Audio('暂无该用户！')
      //       var url = noUserMp3
      //       var audio = new Audio(url);
      //       audio.src = url;
      //       audio.play();
      //       that.$message({
      //         message: '暂无该用户！',
      //         type: 'error',
      //         duration:1000
      //       });
      //       clearTimeout(this.overtimeStatus)
      //       setTimeout(function () {
      //         // that.$refs.mqttws.disconnect()
      //         that.$router.push({
      //           path:'/unmanned/wrcIndex'
      //         })
      //       }, 1000);
      //     }
      //   }
      // }
    },

    //登录提示超时
    loginTime(wait){
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(that.logintimeStatus)
        that.loginNumTip=0
        that.isErrorLogin = false
      } else {
        that.logintime=wait
        that.logintime--;
        that.logintimeStatus = setTimeout(function() {
          that.loginTime(that.logintime);
        },1000);
      }
    },

    //登录
    async getLogin(id){
      var that = this
      if(this.isUserLogin == false){
        var data = {
          'login_type': 'finger',
          "cabinet_id": config.deviceId,
          'finger_id':id
        }
      }else{
        var nameSpace = that.userform.username.replace(/(^\s*)|(\s*$)/g, "")
        var username = new RegExp(/^\w{5,20}$/)
        var passSpace = that.userform.password.replace(/(^\s*)|(\s*$)/g, "")
        var password = new RegExp(/^[\w\.]{5,20}$/)
        if(nameSpace == ''){
          that.$message.warning('账号不能为空！')
          return
        }else if(!username.test(nameSpace)){
          that.$message.warning('请输入5-20个字母、数字或下划线的账号！')
          return
        }
        if(passSpace == ''){
          that.$message.warning('密码不能为空！')
          return
        }else if(!password.test(passSpace)){
          that.$message.warning('请输入5-20个字母、数字、小数点或下划线的密码！')
          return
        }
        var data = {
          'login_type': 'account',
          "cabinet_id": config.deviceId,
          'phone':nameSpace,
          'password':passSpace,
        }
      }
      var res = await loginApi.userLogin(data)
      if (res.meta.code == 200) {
        if(that.loginNumTip > 1){
          clearTimeout(that.logintimeStatus)
        }
        that.isErrorLogin = false;//关闭错误提示
        // that.loginNumTip = 0
        localUserInfo.setItem(res.body)
        that.$store.state.eUserInfo = localUserInfo.getItem()
        // sessionStorage.setItem('acceToken',res.body.access_token)
        clearTimeout(that.overtimeStatus)
        if(that.isType == 'wrc'){
          if(res.body.is_admin == '0'){
            if(that.isLoginTips == false){
              that.$message({
                message: res.meta.message,
                type: 'success',
                duration:1000
              });
              var url = loginSuccessMp3
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
            }
            that.isLoginTips = true
            // that.$refs.mqttws.disconnect()
            setTimeout(function () {
              that.toAbiosign()
            }, 1000);
          }else{
            that.$message({
              message: '您没有管理员权限~',
              type: 'error',
              duration:1000
            });
            // text2Audio('您没有管理员权限')
            var url = noAdminMp3
            var audio = new Audio(url);
            audio.src = url;
            audio.play();
            setTimeout(function () {
              // that.$refs.mqttws.disconnect()
              that.$router.push({
                path:'/unmanned/wrcIndex'
              })
            }, 1000);
          }
        }else if(that.isType == 'outStock'){
          that.toOutStock(res.body,res.meta.message)
        }else if(that.isType == 'inStock'){
          that.toInStock(res.body,res.meta.message)
        }
      } else {
        var userInfo = localUserInfo.getItem()
        if(!userInfo){
          if(that.loginNumTip == 0){
            if(that.isErrorLogin == false){
              that.$message.error(res.meta.message)
              // text2Audio(res.meta.message)
            }
          }else{
            that.logintime=3;
            if(that.loginNumTip == 1){
              that.loginTime(that.logintime)
            }
            that.isErrorLogin = true
          }
          that.loginNumTip+=1;
          that.overtime=60
        }
      }
    },
    //跳转到出库
    toOutStock(data,message){
      var that = this;

      var configStorage = JSON.parse(localStorage.getItem('configStorage'))
      if(configStorage){
        if(configStorage.type == '1' && configStorage.unmanShow == '2'){
          if(data.level.indexOf('STOCK_OUT') != '-1'){
            if(that.isLoginTips == false){
              that.$message({
                // message: message,
                message:'登录成功！',
                type: 'success',
                duration:1000
              });
              // text2Audio('登录成功')
              var url = loginSuccessMp3
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
            }
            that.isLoginTips = true
            setTimeout(function(){
              that.$router.push({
                path: '/toolCabinet/CBorrow',
              })
            },1000)
          }else{
            that.$message({
              message: '您没有出库权限~',
              type: 'error',
              duration:1000
            });
            var url = noOutMp3
            var audio = new Audio(url);
            audio.src = url;
            audio.play();
            setTimeout(function () {
              // that.$refs.mqttws.disconnect()
              that.$router.push({
                path:'/unmanned/wrcIndex'
              })
            }, 1000);
          }
        }else if(configStorage.type == '3' && configStorage.unmanShow == '1'){
          if(that.isLoginTips == false){
            that.$message({
              // message: message,
              message:'登录成功！',
              type: 'success',
              duration:1000
            });
            // text2Audio('登录成功')
            var url = loginSuccessMp3
            var audio = new Audio(url);
            audio.src = url;
            audio.play();
          }
          that.isLoginTips = true
          setTimeout(function(){
            that.$router.push({
              path:'/unmanned/wrcOutStockList',
            })
          },1000)
        }
      }
    },
    toInStock(data,message){
      var that = this;
      var configStorage = JSON.parse(localStorage.getItem('configStorage'))
      if(configStorage){
        if(configStorage.type == '1' && configStorage.unmanShow == '2'){
          if(data.is_admin == '0' && data.level.indexOf('STOCK_IN') != '-1'){
            
            if(that.isLoginTips == false){
              that.$message({
                // message: message,
                message:'登录成功！',
                type: 'success',
                duration:1000
              });
              // text2Audio('登录成功')
              var url = loginSuccessMp3
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
            }
            that.isLoginTips = true
            setTimeout(function () {
            that.$router.push({
              path: '/toolCabinet/CAdmin',
            })
            }, 1000);

          }else{
            that.$message({
              message: '您没有管理员权限~',
              type: 'error',
              duration:1000
            });
            var url = noAdminMp3
            var audio = new Audio(url);
            audio.src = url;
            audio.play();
            setTimeout(function () {
              // that.$refs.mqttws.disconnect()
              that.$router.push({
                path:'/unmanned/wrcIndex'
              })
            }, 1000);
          }
          
        }else if(configStorage.type == '3' && configStorage.unmanShow == '1'){
          if(that.isLoginTips == false){
            that.$message({
              // message: message,
              message: '登录成功！',
              type: 'success',
              duration:1000
            });
            // text2Audio('登录成功')
            var url = loginSuccessMp3
            var audio = new Audio(url);
            audio.src = url;
            audio.play();
          }
          that.isLoginTips = true
          setTimeout(function () {
          that.$router.push({
            path:'/unmanned/wrcInStockList',
          })
          }, 1000);
        }
      }
    },
    //跳转到员工录入页
    toAbiosign(){
      var that = this;
      this.$router.push({
        path: '/toolCabinet/CAdmin/CABiosignAture',
        query:{
          'isType':that.isType
        }
      })
    },

    //超时
    overTime(wait){
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        // clearTimeout(that.overtimeStatus)
        // that.$router.go(0)
        that.backUp()
      } else {
        this.overtime=wait
        this.overtime--;
        that.overtimeStatus = setTimeout(function() {
          that.overTime(that.overtime);
        },1000);
      }
    }
  },
  watch :{
    "$store.state.wsMsg":function(newVal){
      console.log('msg2',newVal)
      this.getSkMsg(newVal)
    }
  },
}
</script>

<style lang="less">
.wrcLogin{
  height: 100vh;
  box-sizing: border-box;
  padding: 0.9rem 0 0;
  .errorLogin{
    text-align: left;
    position: fixed;
    z-index: 3002;
    background: #fff;
    border-radius: 0.1rem;
    font-size: 0.36rem;
    color: #666;
    padding: 0.2rem;
    top: 20%;
    left: 50%;
    width: 20%;
    margin-left: -10%;
    i{ margin-right: 0.1rem; }
  }
  .backUp{
    position: absolute;
    right: 0.94rem;
    bottom: 0.47rem;
    height: 0.94rem;
    width: 2.54rem;
    padding: 0;
    font-size: 0.4rem;
    color: #fff;
    font-weight: bold;
    border: none;
    border-radius: 0.12rem;
    line-height:0.94rem;
    background: linear-gradient(#4aaafe, #0769be);
  }
  .userLoginBtn{
    position: absolute;
    left: 0.94rem;
    top: 0.47rem;
    z-index: 99;
    .el-button{
      height: 0.94rem;
      width: 2.54rem;
      padding: 0;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .back{
    position: absolute;
    right: 5%;
    bottom: 5%;
    z-index: 99;
    .el-button{
      height: auto;
      padding: 0.1rem 0.3rem;
      font-size: 0.18rem;
      border: 0.01rem solid #ddd;
      border-radius: 0.08rem;
      line-height:inherit;
    }
  }
  .mb30{
    margin-bottom: 0.3rem;
  }
  .mb40{
    margin-bottom: 0.4rem;
  }
  .title{
    font-size: 0.72rem;
  }
  .tips{
    font-size: 0.48rem;
    color: #e2e1e1;
  }
  .content2{ 
    width:60%;
    margin:1.5rem auto 0;
    .el-form-item{ margin-bottom: 0.4rem;}
    .el-form-item__label{
      font-size: 0.4rem;
      color: #fff;
      line-height: 0.8rem;
      padding: 0 0.12rem 0 0;
    }
    .el-form-item__content {
      line-height: 0.8rem;
      font-size: 0.3rem;
      .el-form-item__error{
        font-size: 0.3rem;
      }
      .confirm{
        height: 0.94rem;
        padding: 0 !important;
        font-size: 0.4rem !important;
        color: #fff;
        font-weight: bold;
        border: none;
        border-radius: 0.12rem;
        line-height:0.94rem;
        background: linear-gradient(#4aaafe, #0769be);
        width: 100%;
        &.isLoading{
          background: rgba(151, 205, 252,.5);
        }
        span{
          display: flex;
          align-items: center;
          justify-content: center;
        }
        img{
          width: 0.5rem;
          height: 0.5rem;
          margin-right: 0.2rem;
        }
      }
      .el-input__inner{
        height: 0.8rem;
        line-height: 0.8rem;
        padding: 0 0.15rem;
        color: #fff;
        font-size: 0.3rem;
        background: none;
        border: none;
        border-bottom: 0.01rem solid #fff;
      }
    }
  }
  .content{
    padding-top: 0.5rem;
    justify-content: center;
    .item{
      margin: 0 0.98rem;
      width: 6.91rem;
      height: 6.91rem;
      box-sizing: border-box;
      .subTit{
        color: #fff;
        font-size: 0.48rem;
      }
      .img{
        position: relative;
        width: 4.74rem;
        height: 4.74rem;
        margin: 1.09rem auto 0;
        background: #cad5de;
        display: flex;
        justify-content: center;
        align-items: center;
        &::before{
          content: "";
          width: 0.68rem;
          height: 5.92rem;
          box-sizing: border-box;
          border-top: 0.05rem solid #fff;
          border-left: 0.05rem solid #fff;
          border-bottom: 0.05rem solid #fff;
          position: absolute;
          left: -1.09rem;
          top: -0.59rem;
        }
        &::after{
          content: "";
          width: 0.68rem;
          height: 5.92rem;
          box-sizing: border-box;
          border-top: 0.05rem solid #fff;
          border-right: 0.05rem solid #fff;
          border-bottom: 0.05rem solid #fff;
          position: absolute;
          right: -1.09rem;
          top: -0.59rem;
        }
        .loginTips{
          font-size: 0.26rem;
          color: #999;
          position: absolute;
          bottom: 0.4rem;
          left: 0;
          width: 100%;
          text-align: center;
          padding: 0 0.3rem;
          box-sizing: border-box;
        }
      }
      
    }
  }
  .configBtn{
    position: absolute;
    right: 0.94rem;
    top: 0.47rem;
    z-index: 99;
    .el-button{
      height: 0.94rem;
      // width: 2.54rem;
      padding: 0 0.6rem;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CUnmanned/wrcLogin.vue